const paperData = [
  {
    id: 1,
    title:
      "Exploring Fairy Cursor as a Form of AI Agent for In-the-Flow Assistance: Design Opportunities and Challenges",
    authors: "Yining Cao, James D. Hollan, Haijun Xia",
    venue: "DIS 2026",
    thumbnail: "/images/thumbnails/fairy_thumbnail.png",
    award: "Best Paper Award | TOP 1%",
    links: [
      { label: "paper", url: "/fairycursor.pdf" },
      { label: "talk", url: "https://youtu.be/K1cZihVY95g" },
    ],
  },
  {
    id: 1,
    title: "Tidynote: Always-Clear Notebook Authoring",
    authors:
      "Ruanqianqian Huang, Brian Hempel, Yining Cao, James D. Hollan, Haijun Xia, Sorin Lerner",
    venue: "CHI 2026",
    thumbnail: "/images/thumbnails/tidynote_thumbnail.png",
    links: [
      { label: "paper", url: "https://dl.acm.org/doi/10.1145/3772318.3791919" },
      { label: "arxiv", url: "https://arxiv.org/abs/2602.23490" },
    ],
  },
  {
    id: 1,
    title:
      "VizCrit: Exploring Strategies for Displaying Computational Feedback in a Visual Design Tool",
    authors:
      "Mingyi Li, Mengyi Chen, Sarah Luo, Yining Cao, Haijun Xia, Maitraye Das, Steven P. Dow, Jane L. E",
    venue: "CHI 2026",
    thumbnail: "/images/thumbnails/vizcrit_thumbnail.png",
    links: [
      { label: "paper", url: "https://dl.acm.org/doi/10.1145/3772318.3791579" },
      { label: "arxiv", url: "https://arxiv.org/abs/2603.04754" },
    ],
  },
  {
    id: 1,
    title:
      "Generative and Malleable User Interfaces with Generative and Evolving Task-Driven Data Model",
    authors: "Yining Cao, Peiling Jiang, Haijun Xia",
    venue: "CHI 2025",
    thumbnail: "/images/thumbnails/jelly.png",
    links: [
      { label: "project", url: "/project/jelly" },
      { label: "paper", url: "https://dl.acm.org/doi/10.1145/3706598.3713285" },
      { label: "video", url: "https://youtu.be/4T2ZaYowubA" },
      { label: "arxiv", url: "https://arxiv.org/abs/2503.04084" },
    ],
  },
  {
    id: 2,
    title:
      "Compositional Structures as Substrates for Human-AI Co-creation Environment: A Design Approach and A Case Study",
    authors:
      "Yining Cao, Yiyi Huang, Anh Truong, Hijung Valentina Shin, Haijun Xia",
    venue: "CHI 2025",
    thumbnail: "/images/thumbnails/videOrigami.png",
    links: [
      {
        label: "paper",
        url: "https://dl.acm.org/doi/full/10.1145/3706598.3713401",
      },
      { label: "video", url: "https://youtu.be/U31u_uaBK-Y" },
      {
        label: "blog",
        url: "https://research.adobe.com/news/an-experimental-new-design-approach-for-human-ai-co-creation/",
      },
      { label: "arxiv", url: "https://arxiv.org/pdf/2503.04103" },
    ],
  },
  {
    id: 3,
    title: "Malleable Overview-Detail Interfaces",
    authors: "Bryan Min, Allen Chen, Yining Cao, Haijun Xia",
    venue: "CHI 2025",
    thumbnail: "/images/thumbnails/malleable-odi.png",
    links: [
      {
        label: "paper",
        url: "https://dl.acm.org/doi/10.1145/3706598.3714164",
      },
      {
        label: "video",
        url: "https://www.youtube.com/watch?v=XOlhkhsxREY",
      },
      {
        label: "arxiv",
        url: "https://arxiv.org/abs/2503.07782",
      },
    ],
  },
  {
    id: 5,
    title:
      "Elastica: Adaptive Live Augmented Presentations with Elastic Mappings Across Modalities",
    authors:
      "Yining Cao, Rubaiat Habib Kazi, Li-Yi Wei, Deepali Aneja, Haijun Xia",
    venue: "CHI 2024",
    thumbnail: "/images/thumbnails/elastica.png",
    links: [
      { label: "paper", url: "https://dl.acm.org/doi/10.1145/3613904.3642725" },
      {
        label: "video",
        url: "https://youtu.be/HGN3Wc1cVgo?si=S7cIpd5gq9SQGE7t",
      },
    ],
  },
  {
    id: 6,
    title:
      "DataParticles: Block-based and Language-oriented Authoring of Animated Unit Visualizations",
    authors: "Yining Cao, Jane L E, Zhutian Chen, Haijun Xia",
    venue: "CHI 2023",
    thumbnail: "/images/thumbnails/dp-thumbnail.gif",
    award: "Best Paper Award | TOP 1%",
    links: [
      {
        label: "paper",
        url: "https://dl.acm.org/doi/full/10.1145/3544548.3581472",
      },
      {
        label: "video",
        url: "https://youtu.be/HXTn_OHXZZA?si=_9WHCMhgq_EuL0Mb",
      },
    ],
  },
  {
    id: 7,
    title: "VideoSticker: A Tool for Active Visual Note-taking and Annotation",
    authors: "Yining Cao, Hariharan Subramonyam, Eytan Adar",
    venue: "IUI 2022",
    thumbnail: "/images/thumbnails/vs.png",
    links: [
      {
        label: "paper",
        url: "https://dl.acm.org/doi/10.1145/3490099.3511132",
      },
      {
        label: "video",
        url: "https://youtu.be/JO1z1wP0V04?si=xrI9KpkhMiFICySD",
      },
      {
        label: "blog",
        url: "https://hai.stanford.edu/news/new-app-videosticker-uses-ai-help-students-take-rich-notes-video-lessons",
      },
    ],
  },
];

export default paperData;
